import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  methods: {
    async reportHasilAuditPerRekomendasi(val, opsi) {
      const reportData = await this.loadDataReportPerRekomendasi(val, opsi);

      const docDef = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [17, 85, 17, 30],
        header: [
          {
            text: localStorage.namaUnit,
            fontSize: 14,
            bold: true,
            margin: [17, 20, 0, 3],
          },
          {
            text: "Rekapitulasi Temuan dan Tindaklanjut Berdasarkan Group Rekomendasi",
            fontSize: 13,
            margin: [17, 0, 0, 0],
          },
          {
            text:
              "Periode Pelaporan " + opsi.dateMulai.toLocaleDateString("id"),
            fontSize: 8,
            style: "headerPeriod",
            margin: [0, 0, 17, 3],
          },
          {
            text: "sd. " + opsi.dateSelesai.toLocaleDateString("id"),
            fontSize: 8,
            margin: [0, 0, 17, 7],
            style: "headerPeriod",
          },
        ],

        footer: function (currentPage, pageCount) {
          return {
            columns: [
              {
                text: "Tanggal Cetak : " + new Date().toLocaleString("id"),
                margin: [17, 0, 0, 0],
                fontSize: 7,
              },
              {
                text:
                  "halaman ke " + currentPage.toString() + " dari " + pageCount,
                alignment: "right",
                margin: [0, 0, 40, 0],
                fontSize: 7,
              },
            ],
          };
        },

        content: [
          {
            style: "tableExample",
            color: "#444",
            table: {
              widths: [
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
                "auto",
              ],
              // headerRows: 2,
              // keepWithHeaderRows: 1,
              body: [
                [
                  {
                    text: "No",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Sub Kelompok Rekomendasi",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Jumlah Kejadian",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "%",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Nilai Rekomendasi",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Jumlah TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Nilai TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },

                  {
                    text: "Saldo TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "%",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                  {
                    text: "Saldo Nilai TL",
                    style: "tableHeader",
                    bold: true,
                    alignment: "center",
                  },
                ],
                [
                  { text: 1, style: "tableContent" },
                  {
                    text: "Penyetoran ke kas negara/daerah, Kas BUMN/D, dan masyararakat",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiRekomendasi01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlNilaiRekomendasi01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianRekomendasi01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi01,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiRekomendasi01,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 2, style: "tableContent" },
                  {
                    text: "Pengembalian barang kepada negara, daerah, BUMN/D, dan masyarakat",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiRekomendasi02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlNilaiRekomendasi02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianRekomendasi02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi02,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiRekomendasi02,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 3, style: "tableContent" },
                  {
                    text: "Perbaikan fisik barang/jasa dalam proses pembangunan atau penggantian barang/jasa oleh rekanan",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiRekomendasi03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlNilaiRekomendasi03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianRekomendasi03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi03,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiRekomendasi03,
                    style: "tableContent",
                  },
                ],
                [
                  { text: 4, style: "tableContent" },
                  {
                    text: "Penghapusan barang milik negara/daerah",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi04,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi04,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi04,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi04,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi04,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 5, style: "tableContent" },
                  {
                    text: "Pelaksanaan sanksi administrasi kepegawaian",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi05,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi05,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi05,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi05,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi05,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 6, style: "tableContent" },
                  {
                    text: "Perbaikan laporan dan penertiban administrasi/kelengkapan administrasi",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi06,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi06,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi06,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi06,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi06,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 7, style: "tableContent" },
                  {
                    text: "Perbaikan sistem dan prosedur akuntansi dan pelaporan",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi07,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi07,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi07,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi07,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi07,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],

                [
                  { text: 8, style: "tableContent" },
                  {
                    text: "Peningkatan kualitas dan kuantitas sumber daya manusia pendukung sistem pengendalian",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi08,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi08,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi08,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi08,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi08,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 9, style: "tableContent" },
                  {
                    text: "Perubahan atau perbaikan prosedur, peraturan dan kebijakan",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi09,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi09,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi09,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi09,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi09,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 10, style: "tableContent" },
                  {
                    text: "Perubahan atau perbaikan struktur organisasi",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi10,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi10,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi10,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi10,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi10,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 11, style: "tableContent" },
                  {
                    text: "Koordinasi antar instansi termasuk juga penyerahan penanganan kasus kepada instansi yang berwenang",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi11,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi11,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi11,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi11,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi11,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 12, style: "tableContent" },
                  {
                    text: "Pelaksanaan penelitian oleh Tim khusus atau audit lanjutan oleh unit pengawas intern",
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahKejadianRekomendasi12,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi12,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi12,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi12,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi12,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 13, style: "tableContent" },
                  { text: "Pelaksanaan sosialisasi", style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianRekomendasi13,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi13,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi13,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi13,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi13,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  { text: 14, style: "tableContent" },
                  { text: "Lain-lain", style: "tableContent" },
                  {
                    text: reportData?.jumlahKejadianRekomendasi14,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseJumlahKejadianRekomendasi14,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi14,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                  {
                    text: reportData?.saldoKejadianRekomendasi14,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseSaldoKejadianRekomendasi14,
                    style: "tableContent",
                  },
                  { text: "-", style: "tableContent" },
                ],
                [
                  {
                    text: "Jumlah",
                    style: "tableContent",
                    colSpan: 2,
                    bold: true,
                  },
                  {},
                  {
                    text: reportData?.jumlahKejadianRekomendasi,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseTotalKejadianRekomendasi,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahNilaiRekomendasi,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlKejadianRekomendasi,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.jumlahTlNilaiRekomendasi,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoKejadianRekomendasi,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.persentaseTotalSaldoRekomendasi,
                    style: "tableContent",
                  },
                  {
                    text: reportData?.saldoNilaiRekomendasi,
                    style: "tableContent",
                  },
                ],
              ],
            },

            layout: {
              paddingTop: function (i, node) {
                return 4;
              },
              paddingBottom: function (i, node) {
                return 4;
              },
              // fillColor: function (rowIndex, node, columnIndex) { return null; }
            },
          },
        ],
        styles: {
          headerPeriod: {
            alignment: "right",
          },
          tableHeader: {
            alignment: "center",
            fontSize: 10,
          },
          tableContent: {
            fontSize: 10,
          },
          tableSubHeader: {
            alignment: "left",
            fontSize: 8,
            bold: true,
          },
        },
      };

      pdfMake.createPdf(docDef).open();
    },

    async loadDataReportPerRekomendasi(val, opsi) {
      try {
        const response = await axios({
          method: "GET",
          baseURL: this.$apiAddress,
          url: val.endpoint,
          params: {
            token: localStorage.getItem("api_token"),
            fromDate: opsi.dateMulai.toLocaleDateString("fr-CA"),
            toDate: opsi.dateSelesai.toLocaleDateString("fr-CA"),
          },
        });

        if (response.status == 200) {
          const responseData = await response.data;
          // console.log("--> Response DATA : ", responseData);
          return responseData;
        }
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
